import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/Icon';
import { Tag } from '~/components/Tag';
import { Tooltip } from '~/components/Tooltip';

interface ArtistAppliedFilterListItemProps {
  label: string;
  tooltipContent?: ReactNode | null;
  onRemove: () => void;
}

export const ArtistAppliedFilterListItem = ({
  label,
  tooltipContent,
  onRemove,
}: ArtistAppliedFilterListItemProps) => {
  const { t } = useTranslation('roster');

  return (
    <Tag variant="secondary" className="gap-xs pr-xs">
      <Tooltip
        content={tooltipContent}
        enabled={!!tooltipContent}
        delayDuration={0}
        side="top"
        sideOffset={6}
        size="sm"
      >
        {label}
      </Tooltip>
      <button
        onClick={onRemove}
        className="px-2xs"
        data-testid={`remove ${label}`}
        aria-label={t('filters.removeFilter', { filter: label })}
      >
        <Icon type="xmark" variant="regular" size="md" />
      </button>
    </Tag>
  );
};

ArtistAppliedFilterListItem.displayName = 'ArtistAppliedFilterListItem';
